var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimEntity/ForgeRefs.ts";
import * as t from 'io-ts';
import { Urn } from '../Urn';
import { Version } from '../Version';
export var ForgeRefs = t.array(t.type({
  urn: Urn,
  externalId: t.string
}, 'ForgeRefs'));
export var ForgeData = t.type({
  forgeVersion: Version,
  forgeVersionName: t.number
}, 'ForgeData');